import type { ReferenceLineDirection } from './types';

/** 参考线方向常量的键。 */
type ReferenceLineDirectionKey = 'HORIZONTAL' | 'VERTICAL';

/** 参考线数据使用的稳定方向值。 */
export const REFERENCE_LINE_DIRECTION: Record<ReferenceLineDirectionKey, ReferenceLineDirection> = {
    /** 水平参考线。 */
    HORIZONTAL: 'horizontal',
    /** 垂直参考线。 */
    VERTICAL: 'vertical',
};

/** reference-lines 写入 StageOperate 通用历史扩展时使用的稳定命名空间。 */
export const REFERENCE_LINES_STAGE_HISTORY_NAMESPACE = 'reference-lines';
